
// import { motion } from "framer-motion";
// import { FaUser, FaLock, FaHome } from "react-icons/fa";
// import { Link, useNavigate } from "react-router-dom";
// import { useState } from "react";
// import InputField from "../components/InputField";
// import loginImg from "../assets/images/amass-pros-login-img.webp";
// import "./Login.css";
// import "./AuthResponsive.css";

// export default function Login() {
//     const navigate = useNavigate();
//     const [form, setForm] = useState({
//         loginUserId: "",
//         loginPassword: ""
//     });
//     const [errors, setErrors] = useState({});
//     const [touched, setTouched] = useState({});

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prev) => ({ ...prev, [name]: value }));
//         if (touched[name]) {
//             setErrors((prev) => ({
//                 ...prev,
//                 [name]: value.trim() ? "" : "Please enter."
//             }));
//         }
//     };

//     const handleBlur = (e) => {
//         const { name, value } = e.target;
//         setTouched((prev) => ({ ...prev, [name]: true }));
//         setErrors((prev) => ({
//             ...prev,
//             [name]: value.trim() ? "" : "Please enter."
//         }));
//     };

//     const handleSignIn = () => {
//         const nextErrors = {
//             loginUserId: form.loginUserId.trim() ? "" : "Please enter User ID.",
//             loginPassword: form.loginPassword.trim() ? "" : "Please enter Password."
//         };
//         setErrors(nextErrors);
//         setTouched({ loginUserId: true, loginPassword: true });
//         if (nextErrors.loginUserId || nextErrors.loginPassword) return;
//         navigate("/login-otp");
//     };

//     return (
//         <div className="auth-page">
//             <div className="auth-container">
//                 <div className="auth-left">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         onClick={() => navigate("/", { replace: true })}
//                         type="button"
//                         className="back-btn"
//                     >
//                        <FaHome />Home
//                     </motion.button>
//                     <motion.div
//                         initial={{ opacity: 0, y: -20 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.6 }}
//                     >
//                         <h1>HAPPY TO SEE YOU</h1>
//                         <p>Sign in to your account</p>
//                     </motion.div>

//                     <motion.div
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         transition={{ duration: 0.6, delay: 0.2 }}
//                     >
//                         <div className="login-form">
//                             <InputField
//                                 icon={<FaUser />}
//                                 placeholder="User ID"
//                                 name="loginUserId"
//                                 autoComplete="off"
//                                 value={form.loginUserId}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                             />
//                             {touched.loginUserId && errors.loginUserId ? (
//                                 <p className="field-note error">{errors.loginUserId}</p>
//                             ) : null}
//                             <InputField
//                                 icon={<FaLock />}
//                                 type="password"
//                                 placeholder="Password"
//                                 name="loginPassword"
//                                 autoComplete="new-password"
//                                 value={form.loginPassword}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                             />
//                             {touched.loginPassword && errors.loginPassword ? (
//                                 <p className="field-note error">{errors.loginPassword}</p>
//                             ) : null}

//                             <motion.button
//                                 whileHover={{ scale: 1.02 }}
//                                 whileTap={{ scale: 0.98 }}
//                                 className="btn"
//                                 onClick={handleSignIn}
//                             >
//                                 Sign In
//                             </motion.button>

//                             <p className="login-link">
//                                 Don't have an account? <Link to="/register">Create one</Link>
//                             </p>
//                         </div>
//                     </motion.div>
//                 </div>

//                 <div className="auth-right">
//                     <img src={loginImg} alt="Login" className="login-image" />
//                 </div>
//             </div>
//         </div>
//     );
// }
import { motion } from "framer-motion";
import { FaUser, FaLock, FaHome, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import InputField from "../components/InputField";
import loginImg from "../assets/images/amass-pros-login-img.webp";
import "./Login.css";
import "./AuthResponsive.css";

const LOGIN_API = "http://localhost:8080/api/auth/login";

export default function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    loginUserId: "",
    loginPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let nextValue = value;

    if (name === "loginUserId") {
      nextValue = value.toUpperCase().replace(/[^A-Z0-9-]/g, "");
    }

    const nextForm = { ...form, [name]: nextValue };
    setForm(nextForm);

    if (touched[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: nextValue.trim() ? "" : "Please enter.",
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors((prev) => ({
      ...prev,
      [name]:
        value.trim()
          ? ""
          : name === "loginUserId"
          ? "Please enter User ID."
          : "Please enter Password.",
    }));
  };

  const handleSignIn = async () => {
    const nextErrors = {
      loginUserId: form.loginUserId.trim() ? "" : "Please enter User ID.",
      loginPassword: form.loginPassword.trim() ? "" : "Please enter Password.",
    };

    setErrors(nextErrors);
    setTouched({ loginUserId: true, loginPassword: true });

    if (nextErrors.loginUserId || nextErrors.loginPassword) return;

    try {
      setLoading(true);

      const payload = {
        registrationId: form.loginUserId.trim().toUpperCase(),
        password: form.loginPassword,
      };

      const res = await axios.post(LOGIN_API, payload, {
        headers: { "Content-Type": "application/json" },
        timeout: 20000,
      });

      if (res?.data?.token) localStorage.setItem("token", res.data.token);
      if (res?.data?.registrationId)
        localStorage.setItem("registrationId", res.data.registrationId);
      if (res?.data?.referralId)
        localStorage.setItem("referralId", res.data.referralId);
      if (res?.data?.fullName)
        localStorage.setItem("fullName", res.data.fullName);

      await Swal.fire({
        icon: "success",
        title: "Login Successful",
        html:
          "<b>Welcome back!</b><br/><br/>" +
          "You have successfully signed in.<br/>" +
          "Click continue to proceed.",
        confirmButtonText: "Continue",
        confirmButtonColor: "#16a34a",
      });

      navigate("/", { replace: true });
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        (typeof err?.response?.data === "string" ? err.response.data : null) ||
        err?.message ||
        "Login failed. Please try again.";

      await Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: msg,
        confirmButtonText: "Try Again",
        confirmButtonColor: "#ef4444",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-left">
          <motion.button
            whileHover={{ scale: 1.05 }}
            onClick={() => navigate("/", { replace: true })}
            type="button"
            className="back-btn"
          >
            <FaHome />Home
          </motion.button>

          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>HAPPY TO SEE YOU</h1>
            <p>Sign in to your account</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="login-form">
              <InputField
                icon={<FaUser />}
                placeholder="User ID"
                name="loginUserId"
                autoComplete="off"
                value={form.loginUserId}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.loginUserId && errors.loginUserId ? (
                <p className="field-note error">{errors.loginUserId}</p>
              ) : null}

              <InputField
                icon={<FaLock />}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="loginPassword"
                autoComplete="new-password"
                value={form.loginPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                rightIcon={showPassword ? <FaEyeSlash /> : <FaEye />}
                onRightIconClick={() => setShowPassword((prev) => !prev)}
                rightAriaLabel={showPassword ? "Hide password" : "Show password"}
              />
              {touched.loginPassword && errors.loginPassword ? (
                <p className="field-note error">{errors.loginPassword}</p>
              ) : null}

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="btn"
                onClick={handleSignIn}
                type="button"
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
              </motion.button>

              <p className="login-link">
                Don't have an account? <Link to="/register">Create one</Link>
              </p>
            </div>
          </motion.div>
        </div>

        <div className="auth-right">
          <img src={loginImg} alt="Login" className="login-image" />
        </div>
      </div>
    </div>
  );
}
